import { isIOS, isMacOs } from 'react-device-detect';
import { type Format } from './types';

export const getFormat = (): Format => {
  // Crawlers and some embedded webviews have no MediaRecorder at all; reading a
  // property off it would throw during render.
  if (
    typeof MediaRecorder !== 'undefined' &&
    typeof MediaRecorder.isTypeSupported == 'function'
  ) {
    if (MediaRecorder.isTypeSupported('audio/webm')) {
      return 'webm';
    } else {
      return 'mp4';
    }
  } else {
    if (isIOS || isMacOs) {
      return 'mp4';
    } else {
      return 'webm';
    }
  }
};
